import { MAIN_CTA } from "../data/content";
import { Reveal } from "./Reveal";

export const MainCTA = () => (
    <section
        data-testid="cta-utama-section"
        aria-labelledby="cta-utama-title"
        className="relative bg-bh-deep py-24 sm:py-28 overflow-hidden"
    >
        <div aria-hidden="true" className="absolute inset-0 pattern-star-gold opacity-[0.06]" />
        <div
            aria-hidden="true"
            className="absolute -bottom-40 left-1/2 -translate-x-1/2 w-[640px] h-[640px] rounded-full bg-bh-green/30 blur-3xl"
        />
        <Reveal className="relative max-w-4xl mx-auto px-6 sm:px-8 text-center">
            <h2
                id="cta-utama-title"
                data-testid="cta-utama-title"
                className="font-serif font-bold text-3xl sm:text-4xl lg:text-5xl leading-tight tracking-tight text-white"
            >
                {MAIN_CTA.title}
            </h2>
            <p className="mt-5 text-base sm:text-lg tracking-[0.14em] uppercase text-bh-softgold font-semibold">
                {MAIN_CTA.subtitle}
            </p>
            <a
                href="#daftar"
                data-testid="cta-utama-daftar"
                className="mt-10 inline-flex items-center justify-center rounded-full bg-bh-gold px-10 py-4 text-sm font-bold uppercase tracking-[0.14em] text-bh-ink shadow-[0_16px_40px_rgba(217,164,65,0.35)] transition-all duration-300 hover:bg-bh-softgold hover:-translate-y-0.5"
            >
                {MAIN_CTA.button}
            </a>
        </Reveal>
    </section>
);
